import React, { useContext } from "react";

import { Menu, MenuButton, MenuList, MenuItem, Avatar } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

import SignOutService from "services/SignOutService";

import { NavLink } from "react-router-dom";

import { UserDataContext } from "contexts/UserDataContext";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";

import navbar_open_sidebar_icon from "../../assets/images/icons/navbar/navbar_open_sidebar_icon.png";
import HeaderLogo from "../../assets/images/logos/logo-header.png";

export default function Navbar(props) {
  const { userData } = useContext(UserDataContext);

  const { mode } = props;

  const location = useLocation();

  const pattern = /^\/user\/suppliers\/[a-f0-9-]+$/;

  const is_at_supplier_detail = pattern.test(location.pathname);

  const handleSignOut = () => {
    // localStorage.clear();
    SignOutService();
    // window.location.href = "/public/";
  };

  return (
    <div className="bg-black h-16 flex flex-row justify-between z-50 sticky top-0 w-full px-6 py-1 ">
      <div className="text-white flex flex-row gap-2">
        <div
          className={` ${
            is_at_supplier_detail ? "" : "lg:hidden"
          }  my-auto hover:cursor-pointer hover:opacity-50 `}
        >
          <img
            className="h-6 w-6"
            src={navbar_open_sidebar_icon}
            onClick={props.openSmallSidebar}
          />
        </div>
        <div className=" ml-6 my-auto hidden sm:block ">
          <img className="w-[9.3rem] h-[2.0rem]" src={HeaderLogo} />
        </div>
      </div>
      <div className="flex flex-row gap-6">
        {false && (
          <div className="text-white flex flex-col justify-center hover:cursor-pointer hover:opacity-70 ">
            <NotificationsIcon />
          </div>
        )}
        <Menu>
          <MenuButton rightIcon={<KeyboardArrowDownIcon />}>
            <div className="flex flex-row">
              <Avatar
                name={
                  Object.keys(userData).length === 0
                    ? ""
                    : `${userData.first_name} ${userData.last_name}`
                }
                size="md"
              />
              <span className="ml-2 pt-2   text-white ">
                <KeyboardArrowDownIcon />
              </span>
            </div>
          </MenuButton>
          <MenuList>
            {mode !== "admin" && (
              <>
                <NavLink to={"/user/help_and_support"}>
                  <MenuItem className="">
                    <div className="flex flex-row gap-3 justify-center ">
                      <div className="secondary-color-text flex flex-col justify-center ">
                        <HelpRoundedIcon />
                      </div>
                      <div className="flex flex-col justify-center">
                        <p>Help & Support</p>
                      </div>
                    </div>
                  </MenuItem>
                </NavLink>
                <NavLink to="/user/profile">
                  <MenuItem>
                    <div className="flex flex-row gap-3">
                      <div className="secondary-color-text">
                        <AccountCircleIcon />
                      </div>
                      <div className="flex flex-col justify-center">
                        <p>My Profile</p>
                      </div>
                    </div>
                  </MenuItem>
                </NavLink>{" "}
              </>
            )}
            <MenuItem onClick={handleSignOut}>
              <div className="flex flex-row gap-3">
                <div className="secondary-color-text">
                  <LoginRoundedIcon />
                </div>
                <div className="flex flex-col justify-center">
                  <p>Sign Out</p>
                </div>
              </div>
            </MenuItem>
          </MenuList>
        </Menu>
      </div>
    </div>
  );
}
